module.exports = __webpack_public_path__ + "img/duiwubtns_sel.25c470ca.png";